export default __webpack_public_path__ + "/dist/images/3612406.7bccf5d87736af47d77e3b41ba1045f3.png";